import * as Yup from 'yup';
import {
  EFormTags,
  IFormSection,
} from '../../shared/interfaces/form-interfaces';

export const form: IFormSection[] = [
  {
    id: 'SignupCompanyForm',
    items: [
      {
        name: 'name',
        label: 'Nome do Negócio',
        tag: EFormTags.textField,
      },
      {
        name: 'whatsapp',
        label: 'Whatsapp para agendamentos',
        tag: EFormTags.whatsapp,
      },
      {
        name: 'category',
        label: 'Área de Atuação',
        tag: EFormTags.select,
      },
    ],
  },
  // {
  //   title: 'Qual a sua função no seu negócio?',
  //   items: [
  //     {
  //       name: 'group',
  //       label: 'Função',
  //       tag: EFormTags.select,
  //       options: [
  //         {
  //           label: 'Dono',
  //           value: 'dono',
  //         },
  //         {
  //           label: 'Dono e funcionário',
  //           value: 'funcionario',
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const schema = Yup.object().shape({
  name: Yup.string().required('Nome do negócio é obrigatório'),
  whatsapp: Yup.string()
    .required('Whatsapp é obrigatório')
    .length(11, '11 dígitos'),
  category: Yup.string().required('Área de atuação é obrigatório'),
});

export const initialData = {
  name: '',
  whatsapp: '',
  category: '',
};
